<template>
    <ModalBase :show-modal="showModal" @close-modal="close" auto-h extra-narrow>
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal title-modal--simple">
                <template v-slot:title>
                {{ $gettext('Insert password') }}
                </template>
            </TitleBar>
        </template>

        <template v-slot:maincontent>
            <div class="target-item">
                {{ $gettext('Enter the password for your digital certificate to continue. Keep your certificate and its password secure and do not share them with others.') }}
            </div>
            <br />
            <b-form-group :label="$gettext('Certificate password*')" label-for="input-password">
                <b-form-input 
                    id="input-password"
                    type="password"
                    v-model="password"
                    trim
                    required
                    @keyup.enter="setPassword"
                />
            </b-form-group>
        </template>

        <template v-slot:actions>
            <GekkoButton
                @click="close()"
                :text="$gettext('Cancel')"
                variant="light"
            />
            <GekkoButton
                @click="setPassword()"
                :text="$gettext('Upload')"
                class="float-right"
            />
        </template>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase"
import GekkoButton from "@/components/GekkoButton"
import TitleBar from "@/components/TitleBar"

export default {
    name: "PasswordModal",
    components: {
        ModalBase,
        GekkoButton,
        TitleBar
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            password: "",
        }
    },
    methods: {
        close() {
            this.$emit("close")
        },
        setPassword() {
            if (this.password.trim().length > 0) {
                this.$emit("setPassword", this.password)
                this.password = ""
            } else {
                this.$store.commit('setAlert', {
                    title: this.$gettext("Wrong password"),
                    text: this.$gettext("Password cannot be empty"),
                    variant: "danger",
                    duration: 4
                })
            }
        }
    }
}
</script>